export function parsePrice(value: string): { currency: string; value: number} {
    const [currency, valueString] = value.trim().split(' ');
    const valueParsed = parseFloat(valueString);
    return {
        currency,
        value: valueParsed > 0 ? valueParsed : 0,
    };
}
